export const MAX_AUTH_LENGTH = 6;
export const API_KEYS: Record<string, string> = {
  POST_LOG: process.env.REACT_APP_POST_LOG_API_KEY ?? '',
  CAMPS: process.env.REACT_APP_CAMPS_API_KEY ?? '',
};
